import { render, staticRenderFns } from "./DAFO.vue?vue&type=template&id=567a30a4&scoped=true&"
import script from "./DAFO.vue?vue&type=script&lang=js&"
export * from "./DAFO.vue?vue&type=script&lang=js&"
import style0 from "./DAFO.vue?vue&type=style&index=0&id=567a30a4&lang=scss&scoped=true&"
import style1 from "./DAFO.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567a30a4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/ctorres/Documents/Dev/MCD/lsm-app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTextarea } from 'vuetify/lib'
installComponents(component, {VContainer,VIcon,VTextarea})
